import { sleep } from '@flowus/common/async';
import { message } from '@flowus/common/components/message';
import { useOpenModal } from '@flowus/common/next-modal';
import { useAppTranslation } from '@flowus/common/i18n/use-translation';
import { useCallback } from 'react';
import { request } from 'src/common/request/request';

export const useRestoreRole = () => {
  const { t } = useAppTranslation();
  const openModal = useOpenModal();

  return useCallback(
    (pageId: string) => {
      openModal.warning({
        title: t('hooks.restore_role.confirm_title'),
        content: `${t('hooks.restore_role.restore_data_tip')}\n${t(
          'hooks.restore_role.location_may_change'
        )}`,
        confirmText: t('common.confirm'),
        confirm: async () => {
          await request.editor.resetPagePermission(pageId);
          message.success(t('hooks.restore_role.success'));
          await sleep(1000);
          location.reload();
        },
      });
    },
    [openModal, t]
  );
};
